require('app/common');

const Navbar = require('app/component/Navbar');
const Notification = require('app/ui/Notification');
const ModalOrder = require('app/order/ModalShow');
const Loader = require('app/ui/Loader');
const IFrame = require('app/ui/modal/IFrame');

class Application {
    
    defaultOptions() {
        return {
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        window.App = this;//set singleton instance

        this.initialize();
    }

    get(key){
        return this.settings[key] ?? null;
    }

    initialize() {

        this.initNavbar();
        this.initOrderOpening();

        this.initIframeBtns();
    }

	initOrderOpening(){
		let modal = new ModalOrder();
	}

    initIframeBtns(){
        $('body').on('click','.btn-iframe',function(event){
            event.preventDefault();
            event.stopPropagation();
            let $btn = $(this);
            console.log("click on ",$btn);
            let url = $btn.attr('href');
            let size = "full";
            if($btn.data('size')){
                size = $btn.data('size');
            }
            if(!url){
                url = $btn.attr('src');
            }
            if(!url){
                url = $btn.data('href');
            }
            if(url){
                let modal = new IFrame({
                    'modalSize': 'full',
                    'url': url,
                });
                modal.show();
            }
        });


        $('body').on('click','.iframe-close',function(event){

            event.preventDefault();
            event.stopPropagation();

            //wierd behavior to add to let iframe-close button work
            $('body',window.top.document).removeClass('modal-open');
            let $modal =  $('.modal',window.top.document);
            $modal.modal('show');
            $('.modal-backdrop').remove();
            $('.modal-backdrop',window.top.document).remove();
            setTimeout(function(){
                console.log('remove backdrop');
                $('.modal-backdrop').remove();
                $('.modal-backdrop',window.top.document).remove();
                $('.modal',window.top.document).remove();
            },500)

        });
    }

    initNavbar(){
        let $navbar = $('.navbar-restofute');
        if($navbar.length > 0){
            this.navbar = new Navbar({
                '$navbar': $navbar
            })
        }
    }

    setGlobalSearch(search){
        if(this.navbar){
            this.navbar.setSearch(search);
        }
    }

    translate(key,data,domain){
        if(!domain){
            domain = 'messages';
        }

        let translations = this.settings.translations;
        if(!translations[domain]){
            return key;
        }

        let domainTranslations = translations[domain];
        if(!domainTranslations[key]){
            return key;
        }

        let rawTranslation = domainTranslations[key];
        let message = rawTranslation;
        if(data != null){
            let dataKeys = Object.keys(data);

            for(var i in dataKeys){
                let key = dataKeys[i];
                let value = data[key];
                message = message.replace(key,value);
            }
        }
        return message;
    }

    notify(message,level,data,delay){
        if(!data){
            data = null;
        }

        switch(level){
            case 'error':
            case 'err':
            case 'danger':
                data ? console.error(message,data) : console.error(message);
            break;

            case 'warning':
            case 'warn':
                data ? console.warn(message,data) : console.warn(message);
            break;

            case 'success':
            case 'info':
            default:
                //no need to flood the console with success or info
                //data ? console.log(message,data) : console.log(message);
            break;
        }

        var parameters = {
            'type': level,
            'message': message
        };
        if(delay){
            parameters['delay'] = delay;
        }

        new Notification(parameters);
    }

    getMainWindow(){
        if(window.inIframe() && window.parent){
            return window.parent;
        }
        return window;
    }

    getMainDocument(){
        return this.getMainWindow().document;
    }

    getTopDocument(){
        return this.getMainDocument();
    }

    generateLoader(onlyIcon){
        let loader = new Loader({
            'onlyIcon': onlyIcon
        });
        return loader.render();
    }
    
}

module.exports = Application;
